import { render, staticRenderFns } from "./Featured.vue?vue&type=template&id=23456320&scoped=true&"
import script from "./Featured.vue?vue&type=script&lang=js&"
export * from "./Featured.vue?vue&type=script&lang=js&"
import style0 from "./Featured.vue?vue&type=style&index=0&id=23456320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23456320",
  null
  
)

export default component.exports